<ul class="thead text-small">
    <li>{{ "alarm.table.header.channelNumber" | translate }}</li>
    <li>{{ "alarm.table.header.alarmItem" | translate }}</li>
    <li>{{ "alarm.table.header.status" | translate }}</li>
    <li>{{ "alarm.table.header.value" | translate }}</li>
    <li class="narrow table-icon">
        <mat-icon
            *ngIf="showRefresh"
            class="reset-btn"
            svgIcon="refresh"
            (click)="emitRefresh()"
        ></mat-icon>
        <img
            src="assets/icons/sort.svg"
            (click)="onOccurrenceTimeSortClicked()"
        />
    </li>
</ul>
